import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';
import { writePageToken, setPageToken } from '@/components/pagination';

var VatInventoryPage = function (_super) {
  __extends(VatInventoryPage, _super);

  function VatInventoryPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.rowSelection = {};
    _this.warehouseList = [];
    _this.selectedList = [];
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.total = 0;
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    return _this;
  }

  VatInventoryPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.shelved_time_start = this.$util.formatDateTime(arr[0]);
      this.searchData.shelved_time_end = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.shelved_time_start = '';
      this.searchData.shelved_time_end = '';
    }
  };

  VatInventoryPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('仓库'),
      dataIndex: 'warehouse',
      scopedSlots: {
        customRender: 'warehouse'
      }
    }, {
      title: this.t('VAT税号'),
      dataIndex: 'vat_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('商品编码'),
      dataIndex: 'product_sku',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('库存'),
      scopedSlots: {
        customRender: 'total_qty'
      },
      align: 'right',
      filterEmpty: true
    }, {
      title: this.t('入库单/货运单号'),
      dataIndex: 'receiving_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('上架时间'),
      dataIndex: 'shelved_time',
      filterEmpty: true
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
      }
    };
    this.queryInventoryList();
    this.queryWarehouseList();
  };

  VatInventoryPage.prototype.queryInventoryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.rowSelection.selectedRowKeys = this.selectedList = [];
            this.lastParams = this.$util.deepCopy(this.searchData);
            this.total = 0;
            return [4, this.$api.assistant.queryInventoryList(this.searchData)];

          case 1:
            data = _a.sent().data;
            this.dataList = data.list;
            this.searchData.next_token = data.next_token;
            this.searchData.prev_token = data.prev_token;
            writePageToken(this.searchData, {
              prev_token: data.prev_token,
              next_token: data.next_token,
              zt_list_es_point: Number(data.zt_order_list_es_point)
            });
            this.total = data.total;
            return [2];
        }
      });
    });
  };

  VatInventoryPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  VatInventoryPage.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      code_field: 'vat_number',
      code_value: '',
      warehouse_code: undefined,
      shelved_time_start: '',
      shelved_time_end: ''
    };
  };

  VatInventoryPage.prototype.handlePageChange = function (page, pageSize) {
    setPageToken(this.searchData, page);
    this.initPage();
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.queryInventoryList();
  };

  VatInventoryPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryInventoryList();
  };

  VatInventoryPage.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  VatInventoryPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryInventoryList();
  };

  VatInventoryPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryInventoryList();
    });
  };

  VatInventoryPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
              postData["export"] = 1;
              postData.rd_id_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData["export"] = 2;
              postData.rd_id_list = this.selectedList;
            }

            return [4, this.$api.assistant.exportInventory(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], VatInventoryPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], VatInventoryPage.prototype, "queryInventoryList", null);

  __decorate([userPrefPageSize('vatInventoryList')], VatInventoryPage.prototype, "getInitSearchData", null);

  VatInventoryPage = __decorate([Component], VatInventoryPage);
  return VatInventoryPage;
}(Vue);

export default VatInventoryPage;